var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.appClasses},[_c('v-main',[_c('ErrorBoundary',[_c('router-view')],1)],1),(_vm.$store.getters.isLoggedIn)?_c('Navigator',{ref:"navigator",on:{"navigator-state-changed":_vm.onNavigatorStateChanged}}):_vm._e(),(_vm.$store.getters.isLoggedIn)?_c('AiChatDock'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }